import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { components } from '@glowforge/ui-common';
import PhoneNumber from 'app/common/components/forms/phone-number';
import { removePhoneFormat, isValidEmailFormat } from 'app/util';

const { Text, FormField } = components;

const TextWithLink = (props) => {
  const { input, meta, linkUrl, linkText, ...otherProps } = props; // eslint-disable-line no-unused-vars

  const link = (linkUrl && linkText) ? (<div><a href={linkUrl}>{linkText}</a></div>) : null;

  return (
    <FormField {...otherProps} meta={meta}>
      <input
        {...otherProps}
        {...input} />
      {link}
    </FormField>
  );
};

TextWithLink.propTypes = {
  ...Text.propTypes,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
};

TextWithLink.defaultProps = {
  ...Text.defaultProps,
};


const normalizePhone = value => removePhoneFormat(value);

export const validateAccountInfo = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (!isValidEmailFormat(values.email)) {
    errors.email = 'Invalid Email';
  }
  if (values.phone && removePhoneFormat(values.phone).length !== 10) {
    errors.phone = 'Invalid Phone Number';
  }
  if (values.display_name && values.display_name.length > 15) {
    errors.display_name = 'Must be 15 characters or less.';
  }
  // Test name length
  // https://ux.stackexchange.com/a/55540
  const MAX_NAME_LENGTH = 50;
  if (values.first_name && values.first_name.length > MAX_NAME_LENGTH) {
    errors.first_name = 'First name must be 50 characters or less.';
  }
  if (values.last_name && values.last_name.length > MAX_NAME_LENGTH) {
    errors.last_name = 'Last name must be 50 characters or less.';
  }
  // Test for punctuation
  // This same regex is checked in ecomm-core, see PRs for STORE-2790
  // See Facebook's Name Policy https://www.facebook.com/help/292517374180078
  const punctuationRegex = /[!"#$%&()*+,./:;<=>?@^_`{|}~\\]+/g;
  if (punctuationRegex.test(values.first_name)) {
    errors.first_name = 'First name must not contain punctuation.';
  }
  if (punctuationRegex.test(values.last_name)) {
    errors.last_name = 'Last name must not contain punctuation.';
  }

  return errors;
};

const defaultOptions = {
  changeEmailLink: null // put a full URL here if you want to display a change email link
}

// Add options to control changeEmailLink field, which should only be
// displayed on the settings page, not the accept invite page
export const GeneralAccountFields = (disableEmailInput = true, options = defaultOptions) => [
  <Field
    key='firstName'
    className='firstName'
    name='first_name'
    label='First Name'
    autoComplete='given-name'
    component={Text} />,
  <Field
    key='lastName'
    className='lastName'
    name='last_name'
    label='Last Name'
    autoComplete='family-name'
    component={Text} />,
  <Field
    key='displayName'
    className='displayName'
    name='display_name'
    label='Nickname'
    autoComplete='display_name'
    component={Text} />,
  <Field
    key='email'
    className='email'
    name='email'
    label='Email'
    disabled={disableEmailInput}
    linkUrl={options.changeEmailLink}
    linkText='Change email'
    component={TextWithLink} />,
  <Field
    key='phone'
    className='phone'
    name='phone'
    label='Phone'
    normalize={normalizePhone}
    component={PhoneNumber} />,
];



// WEBPACK FOOTER //
// ./app/components/settings/general-account-fields.jsx